import { render, staticRenderFns } from "./AwardCategoryCreate.vue?vue&type=template&id=cd2f649a"
import script from "./AwardCategoryCreate.vue?vue&type=script&lang=js"
export * from "./AwardCategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports